export default {
  USB_CONFIG: {
    vendorId: 0x0d28,
    product_id: 0x0204,
    baudrate: 9600
  }
}
